// Custom polyfills
import './01-helpers/polyfills/Array.findIndex';

import 'amcharts3/amcharts/amcharts';
import 'amcharts3/amcharts/serial';
import 'amcharts3/amcharts/plugins/responsive/responsive';
import 'slick-carousel/slick/slick.js';
import 'pickadate/lib/legacy.js';
import 'pickadate/lib/picker.js';
import 'pickadate/lib/picker.date.js';
import 'pickadate/lib/picker.time.js';
import 'pickadate/lib/translations/nl_NL.js';

import { get as getPageOptions, decodeHtml } from './01-helpers/utilities/options';

import Swal from 'sweetalert2'; // eslint-disable-line no-unused-vars
import React from 'react'; // eslint-disable-line no-unused-vars
import ReactDOM from 'react-dom';
import queryString from 'query-string';
import Scorecard from './components/Scorecard/Scorecard'; // eslint-disable-line no-unused-vars
import FriendsList from './components/Friends/List'; // eslint-disable-line no-unused-vars
import FriendsSearch from './components/Friends/Search'; // eslint-disable-line no-unused-vars
import Courses from './components/Courses/Courses'; // eslint-disable-line no-unused-vars
import CoursesSearch from './components/Courses/Search'; // eslint-disable-line no-unused-vars
import ClubNews from './components/News/News'; // eslint-disable-line no-unused-vars
import Timeline from './components/Timeline/Timeline'; // eslint-disable-line no-unused-vars

import Forms from './modules/forms.js';
import Select from './modules/select.js';
import CreateScorecard from './modules/scorecard-create.js';
import ApproveScorecard from './modules/scorecard-approve.js';
import ToggleScorecard from './modules/scorecard-toggle.js';
import UpdateMarkerScorecard from './modules/scorecard-marker-update.js';
import Notification from './modules/notification.js';
import Modal from './modules/modal.js';
import './modules/profile';
import './modules/datalayer';
import './05-domain/scorecard-form';
import './05-domain/profile-form';
import './05-domain/reject-scorecard-form';
import HandicapHandout from './modules/handicap-handout';
import svg4everybody from 'svg4everybody';

svg4everybody();

// Load SVG Images for SVG Sprite
function requireAll(r) {
	r.keys().forEach(r);
}

requireAll(require.context('../svg/', true, /\.svg$/));

const selectors = {
	handicapHandout: '.js-handicap-handout',
	scorecardToggle: '.js-scorecard-toggle'
}

// Check the tracking header on all AJAX calls
// Uses XMLHttpRequest request
//$(document).ajaxComplete(function (event, request, settings) {
//    const TRACKING_RESPONSE_HEADER_NAME = "trackevent";
//    const trackingHeader = request.getResponseHeader(TRACKING_RESPONSE_HEADER_NAME);
//    console.debug('ajaxComplete called', trackingHeader);
//    if (trackingHeader !== null) {
//        console.debug('a');
//        var data = JSON.parse(trackingHeader);
//        // Push the datalayer
//        if (data.constructor === Array) {
//            console.debug('b');
//            for (var dataItem in data) {
//                console.debug('c', dataItem);
//                dataLayer.push(data[dataItem]);
//            }
//        } else {
//            console.debug('d', data);
//            dataLayer.push(data);
//        }
//    }
//});


// Inits

new Forms();
new Select();
new CreateScorecard();
const scorecardApproval = document.querySelector('.js-scorecard-approval');
if (scorecardApproval !== null || typeof scorecardApproval !== 'undefined') {
    new ApproveScorecard(scorecardApproval);
}

$('.js-notification').each(function() {
    new Notification($(this));
});

$('.js-form-update-marker-scorecard').each(function () {
	new UpdateMarkerScorecard($(this));
});

$('.js-modal-trigger').each(function () {
	new Modal($(this));
});

// React components

const $scorecard = $('#scorecard');
if ($scorecard.length) {
    ReactDOM.render(<Scorecard
        dataUrl={$scorecard.attr('data-dataUrl')}
        postUrl={$scorecard.attr('data-postUrl')}
        cancelUrl={$scorecard.attr('data-cancelUrl')}
        resultPageUrl={$scorecard.attr('data-resultPageUrl')}
        courseId={$scorecard.attr('data-courseId')}
        teeId={$scorecard.attr('data-teeId')}
        loopId={$scorecard.attr('data-loopId')}
        scorecardId={$scorecard.attr('data-scorecardId')}
		qualifying={$scorecard.attr('data-qualifying')}
		competition={$scorecard.attr('data-competition')}
		remark={$scorecard.attr('data-remark')}
        markerId={$scorecard.attr('data-markerId')}
        customMarker={$scorecard.attr('data-customMarker')}
        date={$scorecard.attr('data-date')}
        cardNumber={$scorecard.attr('data-cardNumber')}
        isNoReturn={$scorecard.attr('data-isNoReturn')}
        i18n={{
            cancelButtonText: $scorecard.attr('data-i18n-cancelButtonText'),
            confirm: $scorecard.attr('data-i18n-confirm'),
            confirmNumberOfHolesPlayed: $scorecard.attr('data-i18n-confirmNumberOfHolesPlayed'),            
            course: $scorecard.attr('data-i18n-course'),
            date: $scorecard.attr('data-i18n-date'),
            defaultInputValue: $scorecard.attr('data-i18n-defaultInputValue'),
            editButtonText: $scorecard.attr('data-i18n-editButtonText'),
            holes: $scorecard.attr('data-i18n-holes'),
            loadError: $scorecard.attr('data-i18n-loadError'),
            loading: $scorecard.attr('data-i18n-loading'),
            marker: $scorecard.attr('data-i18n-marker'),
            minHoles: $scorecard.attr('data-i18n-minHoles'),
            motivation: $scorecard.attr('data-i18n-motivation'),
            phcp: $scorecard.attr('data-i18n-phcp'),
            submitButtonText: $scorecard.attr('data-i18n-submitButtonText'),
            submitError: $scorecard.attr('data-i18n-submitError'),
            success: $scorecard.attr('data-i18n-success'),
            tee: $scorecard.attr('data-i18n-tee')
        }}
    />, $scorecard[0]);
}

const $friendsList = $('#friends-list');
if ($friendsList.length) {
    ReactDOM.render(<FriendsList
        urls={{
            get: $friendsList.attr('data-getUrl'),
            remove: $friendsList.attr('data-removeUrl'),
            detail: $friendsList.attr('data-detailUrl')
        }}
        i18n={{
            loading: $friendsList.attr('data-i18n-loading'),
            noResults: $friendsList.attr('data-i18n-noresults'),
            error: $friendsList.attr('data-i18n-error')
        }}
        profilePhotoPlaceholderUrl={$friendsList.attr('data-profilePhotoPlaceholderUrl')}
    />, $friendsList[0]);
}

const $friendsAdd = $('#friends-add');
if ($friendsAdd.length) {
    ReactDOM.render(<FriendsSearch
        urls={{
            get: $friendsAdd.attr('data-getUrl'),
            request: $friendsAdd.attr('data-sendFriendRequestUrl'),
            detail: $friendsAdd.attr('data-detailUrl')
        }}
        i18n={{
            loading: $friendsAdd.attr('data-i18n-loading'),
            error: $friendsAdd.attr('data-i18n-error'),
            inputPlaceholder: $friendsAdd.attr('data-i18n-inputPlaceholder'),
            searchButton: $friendsAdd.attr('data-i18n-searchButton'),
            noResults: $friendsAdd.attr('data-i18n-noResults'),
            isFriend: $friendsAdd.attr('data-i18n-isFriend'),
            invited: $friendsAdd.attr('data-i18n-invited'),
            add: $friendsAdd.attr('data-i18n-add')
        }}
        profilePhotoPlaceholderUrl={$friendsAdd.attr('data-profilePhotoPlaceholderUrl')}
    />, $friendsAdd[0]);
}

const $mycourses = $('#mycourses');
if ($mycourses.length) {
    ReactDOM.render(<Courses
        urls={{
            get: $mycourses.attr('data-getUrl'),
            remove: $mycourses.attr('data-removeUrl')
        }}
        i18n={{
            loading: $mycourses.attr('data-i18n-loading'),
            error: $mycourses.attr('data-i18n-error'),
            homeCourse: $mycourses.attr('data-i18n-homeCourse'),
            otherCourses: $mycourses.attr('data-i18n-otherCourses'),
            remove: $mycourses.attr('data-i18n-remove'),
            noHomeCourse: $mycourses.attr('data-i18n-noHomeCourse'),
            noOtherCourses: $mycourses.attr('data-i18n-noOtherCourses')
        }}
        leadingCoursesUrl={$mycourses.attr('data-leadingCoursesUrl')}
        courseDetailsUrl={$mycourses.attr('data-courseDetailsUrl')}
    />, $mycourses[0]);
}

const $coursesAdd = $('#courses-add');
if ($coursesAdd.length) {
    ReactDOM.render(<CoursesSearch
        urls={{
            get: $coursesAdd.attr('data-getUrl'),
            add: $coursesAdd.attr('data-addUrl')
        }}
        i18n={{
            loading: $coursesAdd.attr('data-i18n-loading'),
            error: $coursesAdd.attr('data-i18n-error'),
            inputPlaceholder: $coursesAdd.attr('data-i18n-inputPlaceholder'),
            searchButton: $coursesAdd.attr('data-i18n-searchButton'),
            noResults: $coursesAdd.attr('data-i18n-noResults'),
            add: $coursesAdd.attr('data-i18n-add')
        }}
    />, $coursesAdd[0]);
}

const $clubnews = $('#clubnews');
if ($clubnews.length) {
    ReactDOM.render(<ClubNews
        urls={{
            get: $clubnews.attr('data-getUrl')
        }}
        i18n={{
            title: $clubnews.attr('data-i18n-title'),
            error: $clubnews.attr('data-i18n-error')
        }}
    />, $clubnews[0]);
}

const $timeline = $('#friendsTimeline');
if ($timeline.length) {
    ReactDOM.render(<Timeline
        urls={{
            get: $timeline.attr('data-getUrl'),
            like: $timeline.attr('data-likeUrl'),
            unlike: $timeline.attr('data-unlikeUrl'),
            detail: $timeline.attr('data-detailUrl')
        }}
        i18n={{
            loading: $timeline.attr('data-i18n-loading'),
            loadingMore: $timeline.attr('data-i18n-loadingMore'),
            error: $timeline.attr('data-i18n-error'),
            errorLoadingMore: $timeline.attr('data-i18n-errorLoadingMore'),
            more: $timeline.attr('data-i18n-more'),
            errorLike: $timeline.attr('data-i18n-errorLike'),
            errorShare: $timeline.attr('data-i18n-errorShare'),
            noResults: $timeline.attr('data-i18n-noResults'),
            share: $timeline.attr('data-i18n-share')
        }}
        profilePhotoPlaceholderUrl={$timeline.attr('data-profilePhotoPlaceholderUrl')}
    />, $timeline[0]);
}

/*=========================================
 *				 UTILITIES 
 *=========================================*/

function readCookie(name) {
	var ca = document.cookie.split(';');
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == ' ') c = c.substring(1, c.length);
		if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
	}
	return null;
}

function createCookie(name, value) {
	document.cookie = name + "=" + value + "; path=/";
}

/*=========================================
 *			 System Notifications 
 *=========================================*/
const systemId = getPageOptions('id');
if (systemId != null && readCookie(`systemnotificationid-${systemId}`) == null) {
	document.addEventListener("DOMContentLoaded", function () {
		Swal.fire({
			title: getPageOptions('title'),
			text: decodeHtml(getPageOptions('text')),
			type: "info",
			showCancelButton: false,
			closeOnConfirm: false,
			showLoaderOnConfirm: true
		}).then((result) => {
			document.cookie = `systemnotificationid-${systemId}=; path=/`;
			Swal.close();
		});
	});
}

/*=========================================
 *			    Date Pickers 
 *=========================================*/

$('.js-datepicker').pickadate({
    container: 'body',
    hiddenName: true,
    formatSubmit: 'yyyy/mm/dd',
    max: new Date(),
    min: function () {
        var d = new Date(); d.setDate(new Date().getDate() - 2); return d;
    }(),
	updateInput: true
});

$('.js-timepicker').pickatime({
    container: 'body',
    formatLabel: 'HH:i',
    formatSubmit: 'HH:i',
    format: 'HH:i',
    hiddenName: true,
    interval: 1
});

// Form file inputs

//$('.js-fileInput').on('change', function() {
//    const context = this;

//    if (this.files && this.files[0]) {
//        var reader = new FileReader();

//		reader.onload = function (e) {
//			const target = $(context).attr('data-target');
//			$(target).css({ 'background-image': 'url(' + e.target.result + ')' });
//		};

//        reader.readAsDataURL(this.files[0]);
//    }
//});

// Buttons

$('.js-button').each(function() {
    $(this).removeClass('is-loading');
    $(this).on('click', function() {
        $(this).addClass('is-loading');
    });
});

// Tooltips

// Show alerts instead of tooltips
if (Modernizr.touchevents) {
    $('[data-tooltip]').on('click', function() {
        alert($(this).attr('data-tooltip'));
    });
}

// Navigation

// Toggle user profile dropdown
if ($('.js-user-nav-toggle').length) {
    $(document).on('click', function(event) {
        if(!$(event.target).parents('.js-user-nav-toggle').is('.js-user-nav-toggle')) {
            $('#user-nav-toggle').prop('checked', false);
        }
    });
}

// Disable scrolling when mobile navigation is visible
$('#nav-toggle').on('change', function() {
    if ($(this).is(':checked')) {
        $('body').css({ overflowY: 'hidden' });
    } else {
        $('body').css({ overflowY: 'visible' });
    }
});

// Iframes
const preloadIframes = function() {
    // preload iframes
    $('iframe').on('load', function() {
        // hide the loader
        $(this).prev('.js-iframe-loader').hide();
    });
};

const initSliders = function() {
    $('.js-slider').slick({
		prevArrow: '<button type="button" data-role="none" class="slick-prev slick-arrow" aria-label="Previous" role="button"></button>',
		nextArrow: '<button type="button" data-role="none" class="slick-next slick-arrow" aria-label="Next" role="button"></button>'
    });
};

const initAds = function() {
    if (typeof (googletag) !== "object" || typeof (googletag.cmd) !== "object") {
        // Google Tag Services must be initialized in the <head> of the page.
        return;
    }

    var ads = $('div[data-type="gpt-ad"]');

    ads.each(function (i, el) {
        var id = el.id;
        var slot = $(this).data('slot');
        var dimensions = $(this).data('dimensions');
        googletag.cmd.push(function () { googletag.defineSlot(slot, dimensions, id).addService(googletag.pubads()) });
    });

    googletag.cmd.push(function () {
        googletag.pubads().enableSingleRequest();
        googletag.pubads().collapseEmptyDivs();
        googletag.enableServices();
    });

    ads.each(function (i, el) {
        googletag.cmd.push(function () { googletag.display(el.id); });
    });
}

preloadIframes();
initSliders();
initAds();

// Partials

// Handle async preloading of sitecore partials
document.querySelectorAll('.PartialContent').forEach((item) => {
    var url = $(item).attr('data-url');
    if (url.length) {
        $(item).load(url, (response, status) => {
            if (status === 'error') {
                // Show text if loading failed
                $(item).html( $(item).attr('data-failText') );
            } else {
                preloadIframes();
				initSliders();

				// Set toggle events on Scorecards if the exist
                document.querySelectorAll(selectors.scorecardToggle).forEach((element) => {
					new ToggleScorecard($(element));
					new Select();
				});

                document.querySelectorAll(selectors.handicapHandout).forEach((element) => {
					new HandicapHandout(element);
				});

				// Scroll to html item if there's an id in the querystring
                if (document.location.search && queryString.parse(location.search).scorecardid) {
                    const id = '#'+queryString.parse(location.search).scorecardid;
                    var scrollTop = $(id).offset().top;
                    $(window).scrollTop(scrollTop);
                }
            }
        });
    }
});
